export default "__VITE_PUBLIC_ASSET__8d8c87c9__"